import { Box, VStack, HStack, Text, Avatar } from '@chakra-ui/react';
import type { ItineraryCanvasserRowDto } from '../../../types/campaign'
import { StaticCellDropZone, STATIC_SENTINEL_KEY } from './StaticCellDropZone'
import { AuthedAvatarImage } from '../../shared'

interface StaticAssignmentGridProps {
  canvassers: ItineraryCanvasserRowDto[]
  onRemove?: (assignmentId: string) => void
}

export function StaticAssignmentGrid({
  canvassers,
  onRemove,
}: StaticAssignmentGridProps) {
  return (
    <Box flex={1} overflowX="auto">
      {/* Header */}
      <HStack
        bg="gray.50"
        px={3}
        py={2}
        borderRadius="md"
        mb={2}
        fontSize="xs"
        fontWeight="semibold"
        color="gray.600"
      >
        <Box w="140px" flexShrink={0}>Canvasser</Box>
        <Box flex={1}>Assigned Turfs</Box>
      </HStack>

      {/* Canvasser rows */}
      <VStack gap={1} align="stretch">
        {canvassers.map(canvasser => {
          const assignments = canvasser.dayAssignments[STATIC_SENTINEL_KEY] ?? []
          return (
            <HStack
              key={canvasser.grantId}
              gap={2}
              align="start"
              py={1}
              px={1}
            >
              {/* Canvasser label */}
              <HStack w="140px" flexShrink={0} gap={2} pt={1}>
                <Avatar.Root size="xs"><Avatar.Fallback name={canvasser.fullName} /><AuthedAvatarImage src={canvasser.portraitUrl} /></Avatar.Root>
                <Text fontSize="xs" fontWeight="medium" lineClamp={1}>
                  {canvasser.fullName}
                </Text>
              </HStack>

              {/* Drop zone */}
              <StaticCellDropZone
                grantId={canvasser.grantId}
                assignments={assignments}
                onRemove={onRemove}
              />
            </HStack>
          );
        })}
      </VStack>

      {canvassers.length === 0 && (
        <Text fontSize="sm" color="gray.400" textAlign="center" py={6}>
          No canvassers in this committee
        </Text>
      )}
    </Box>
  );
}
